import { useEffect, useState } from "react";
import AppShell from "@/components/layout/AppShell";
import StatusBadge from "@/components/common/StatusBadge";
import DataTable from "@/components/common/DataTable";
import api from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CheckCircle, XCircle, User } from "@phosphor-icons/react";

export default function ApprovalHistoryPage() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("all");
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/approvals/history").then((r) => setRows(r.data)).catch(() => {}); }, []);

  const filtered = rows.filter((r) => {
    if (status !== "all" && r.approval_status !== status) return false;
    if (q && !`${r.do_no} ${r.customer} ${r.approved_by_name || ""}`.toLowerCase().includes(q.toLowerCase())) return false;
    return true;
  });

  return (
    <AppShell title="Riwayat Persetujuan" subtitle="Audit trail approve/reject DO oleh Pengawas Pabrik">
      <div className="flex flex-col md:flex-row md:items-center gap-3 mb-5">
        <Input data-testid="hist-search" placeholder="Cari DO, customer, approver…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-sm h-10" />
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="w-48 h-10" data-testid="hist-status"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Semua</SelectItem>
            <SelectItem value="approved">Disetujui</SelectItem>
            <SelectItem value="rejected">Ditolak</SelectItem>
          </SelectContent>
        </Select>
        <span className="ml-auto text-xs font-mono text-slate-500">{filtered.length} keputusan</span>
      </div>

      <DataTable
        testid="hist-table"
        rows={filtered}
        columns={[
          { key: "do_no", label: "No. DO", render: (r) => <span className="font-mono font-bold">{r.do_no}</span> },
          { key: "customer", label: "Customer" },
          { key: "product", label: "Produk" },
          { key: "target_qty", label: "Target", render: (r) => <span className="font-mono">{(r.target_qty || 0).toLocaleString("id-ID")}</span> },
          { key: "approver", label: "Diputuskan Oleh", render: (r) => (
            <div className="flex items-center gap-2 text-[12px]">
              <User size={12} weight="duotone" className="text-slate-500" />
              <div className="leading-tight">
                <div className="font-semibold text-slate-800">{r.approved_by_name || r.approved_by || "-"}</div>
                <div className="text-[10px] font-mono text-slate-500">{r.approved_at ? new Date(r.approved_at).toLocaleString("id-ID") : "-"}</div>
              </div>
            </div>
          )},
          { key: "approval_status", label: "Keputusan", render: (r) => (
            r.approval_status === "approved" ? (
              <span className="inline-flex items-center gap-1.5 text-emerald-700 font-semibold text-[12px]"><CheckCircle size={14} weight="fill" /> Disetujui</span>
            ) : (
              <span className="inline-flex items-center gap-1.5 text-red-700 font-semibold text-[12px]"><XCircle size={14} weight="fill" /> Ditolak</span>
            )
          )},
          { key: "reject_reason", label: "Alasan Tolak", render: (r) => (
            r.reject_reason ? <span className="text-[11px] text-red-700 italic">{r.reject_reason}</span> : <span className="text-slate-300">—</span>
          )},
        ]}
      />
    </AppShell>
  );
}
